function setMainBgOffset () {
  const bannerSection = document.querySelector(
    'section[id$="__slideshow_8MEfh4"]'
  )
  const banner = bannerSection?.querySelector('x-slideshow') || bannerSection
  const main = document.querySelector('main#main.anchor')

  if (!banner || !main) return

  const bannerHeight = banner.getBoundingClientRect().height

  if (bannerHeight > 0) {
    main.style.setProperty('--banner-height', `${bannerHeight}px`)
    main.classList.add('is-bg-ready')
  }
}

/** 源自2026-july活动，页内跳转（#锚点）除外，其余链接新开标签页 */
function forceBSLinksOpenInNewTab () {
  const root = document.querySelector('main#main') || document
  root.querySelectorAll('a[href]').forEach(a => {
    const href = (a.getAttribute('href') || '').trim()
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return
    }
    a.setAttribute('target', '_blank')
    a.setAttribute('rel', 'noopener noreferrer')
  })
}

window.addEventListener('DOMContentLoaded', () => {
  setMainBgOffset()
  forceBSLinksOpenInNewTab()
})
window.addEventListener('load', setMainBgOffset)
window.addEventListener('resize', setMainBgOffset)

setTimeout(setMainBgOffset, 300)
setTimeout(setMainBgOffset, 1000)
